import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { OPERATOR_AVAILABILITY_PROVIDER_QUERY } from "Services/queries";
import { OperatorBanner } from "ComponentsUI/OperatorBanner";
import SubMenuContainer from "Containers/SubMenuOperatorContainer";
import BreadCrumbsContainer from "Containers/BreadCrumbsContainer";
import { generateUrl } from "Services/withDefaultParams";
import images from "Configs/images.config";
import useDefaultParams from "Services/useDefaultParams";
import { BottomPartOperators } from "ComponentsUI/Navigation";
import { replaceStaticHost } from "Helpers/ImageManager";
import smoothScrollTo from "Helpers/Scroll";
import Routes from "Configs/routes";

const OperatorHeaderWrapperContainer = (props) => {
	let tariffsModel = props.ApplicationModel.tariffsModel;
	const routeParams = useParams();
	const { regionUrl } = useDefaultParams(routeParams);

	useEffect(() => {
		if (!props.data.provider && !props.data.loading) {
			const url = generateUrl(Routes.Default.route, {
				regionUrl: regionUrl,
			});
			props.history.push(url);
		}
	}, [props?.data?.provider, props?.data?.loading]);

	const { data, loading } = useQuery(OPERATOR_AVAILABILITY_PROVIDER_QUERY, {
		skip: !props?.data?.provider,
		variables: {
			global_id: props.data?.provider?.global?.id || 0,
			url_region: regionUrl,
		},
	});

	const isStub = props.data.loading;
	const providerTag = loading ? null : data?.operatorAvailabilityProvider;

	const {
		ApplicationModel: { windowSizeModel, text, currentRegion },
	} = props;

	const providerImage =
		!!currentRegion && !!currentRegion.image_lg
			? {
					lg: replaceStaticHost(currentRegion.image_lg),
					md: replaceStaticHost(currentRegion.image_md),
					sm: replaceStaticHost(currentRegion.image_sm),
					xs: replaceStaticHost(currentRegion.image_xs),
				}
			: {
					lg: replaceStaticHost(images.heroBannerLg),
					md: replaceStaticHost(images.heroBannerMd),
					sm: replaceStaticHost(images.heroBannerSm),
					xs: replaceStaticHost(images.heroBannerXs),
				};

	let providerData = null;
	let providerLogo = "";
	let site = "";
	let phone = "";
	let phoneSupport = "";
	let subMenu = <SubMenuContainer stub={isStub} />;
	let header = "";
	let h1After = "";
	let seoData = props.seoData;

	const clickLogoHandler = () => {
		let sizeTariffRow = windowSizeModel.windowSizes.xs ? 470 : 580;

		if (tariffsModel.tariffListRef) {
			let tariffsListRef = tariffsModel.tariffListRef;
			sizeTariffRow = tariffsListRef.offsetTop - 110;
		}
		// Запускается 2 раза скролл, т.к. браузер не всегда нормально ставит скролл с первого раза.
		smoothScrollTo(0, sizeTariffRow);
		setTimeout(() => smoothScrollTo(0, sizeTariffRow), 1);
	};

	if (!isStub) {
		providerData = props.data.provider;

		if (!providerData.hasOwnProperty("id")) {
			return null;
		}
		if (providerData.hasOwnProperty("logo")) {
			providerLogo = replaceStaticHost(providerData.logo);
		}
		if (providerData.hasOwnProperty("contacts")) {
			phone = providerData.contacts.phones[0];
			if (!!phone) {
				phone = phone.replace("(", " (").replace(")", ") ");
			}

			phoneSupport = providerData.contacts.phone_support.join(", ");
			site = providerData.contacts.site;
		}

		subMenu = (
			<SubMenuContainer
				operatorForCard={props.operatorForCard}
				providerTag={providerTag}
				provider={props.data.provider}
				tariffs={props.data.provider.info.cnt_tariffs}
				map={
					!!providerData.order_types.find((item) => item.id == 1) &&
					!providerData?.sell_self?.provider?.url_name
				}
			/>
		);

		header = props.defaultHeader
			? `${props.defaultHeader} ${providerData.name}`
			: seoData && seoData.h1;

		h1After = seoData && seoData.h1After;
	}

	let originalOperator = (
		<OperatorBanner
			isStub={isStub}
			text={text}
			breadCrumbs={!isStub ? <BreadCrumbsContainer /> : null}
			// background={providerImage}
			providerLogo={providerLogo}
			phone={phone}
			phoneSupport={phoneSupport}
			site={site}
			windowSizes={windowSizeModel.windowSizes}
			data={providerData}
			notH1={props.notH1}
			h1={header}
			h1After={h1After}
			clickLogoHandler={clickLogoHandler}
		/>
	);

	if (isStub) {
		return (
			<>
				{originalOperator}
				<BottomPartOperators providerTheme={true} whiteTheme={true} />
			</>
		);
	}

	return (
		<>
			{originalOperator}
			<BottomPartOperators providerTheme={true} whiteTheme={true} menu={subMenu} />
		</>
	);
};

export default inject("ApplicationModel")(observer(OperatorHeaderWrapperContainer));
